// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module_content_2Eswg","doclist":"index-module_doclist_3pJ9D"};